import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { equals, Store } from '@softline/core';
import { Modal } from '@softline/ui-core';
import { Observable } from 'rxjs';
import { ZusatzartikelStore } from '../../store';
import { SOFTLINE_FEATURE_TRANSPORTAUFTRAG_ZUSATZARTIKEL } from '../../transport.shared';
import { Artikel } from '../../types/artikel';
import { ArtikelEinheit } from '../../types/artikel-einheit';
import { BeweauBean } from '../../types/beweau-bean';
import { Zusatzartikel } from '../../types/zusatzartikel';

import { CheckboxComponent, TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-add-item-dialog',
  imports: [CommonModule, CheckboxComponent, TranslatePipe],
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddItemDialogComponent implements Modal<BeweauBean[] | null> {
  private cdRef = inject(ChangeDetectorRef);

  private store = inject(Store);

  close!: (_: BeweauBean[] | null) => void;

  readonly items$: Observable<Zusatzartikel[]> = this.store.observe(
    SOFTLINE_FEATURE_TRANSPORTAUFTRAG_ZUSATZARTIKEL,
    ZusatzartikelStore.getters.data
  );

  private selectedItems: Zusatzartikel[] = [];

  get atLeastOneItemSelected(): boolean {
    return this.selectedItems?.length > 0;
  }

  registerCloseHandler(handler: (result: BeweauBean[] | null) => void) {
    this.close = handler;
  }

  toggleSelect(item: Zusatzartikel): void {
    const index = this.selectedItems.findIndex((o) => equals(item, o));
    if (index !== -1) {
      const selectedItems = [...this.selectedItems];
      selectedItems.splice(index, 1);
      this.selectedItems = selectedItems;
    } else {
      this.selectedItems = [...this.selectedItems, item];
    }

    this.cdRef.detectChanges();
  }

  closeDialog(): void {
    const beweauItems: BeweauBean[] = this.selectedItems.map(
      ({ arteh, artikel, mengeVorschlag }) => ({
        id: undefined,
        artikel,
        arteh,
        menge: mengeVorschlag ?? 1,
      })
    );
    this.close(beweauItems);
  }

  isItemSelected(item: { artikel: Artikel; arteh: ArtikelEinheit }) {
    return this.selectedItems.findIndex((o) => equals(item, o)) > -1;
  }
}
